import type { IconProps } from "./types";

export const Copy = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" style={{ height: "16px", width: "16px" }}>
    <path d="M6.13639 12.2424H2.50002V1.33333H11.5909V4.36364" stroke="#1B4DF5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 6.66667H8.50002V14.6667H14.5V6.66667Z" stroke="#1B4DF5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
